/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AggregierteAuswertungLayoutDto } from '../../models/aggregierte-auswertung-layout-dto';

export interface GetAggregierteAuswertungLayoutById$Plain$Params {
  id: string;
}

export function getAggregierteAuswertungLayoutById$Plain(http: HttpClient, rootUrl: string, params: GetAggregierteAuswertungLayoutById$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AggregierteAuswertungLayoutDto>> {
  const rb = new RequestBuilder(rootUrl, getAggregierteAuswertungLayoutById$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AggregierteAuswertungLayoutDto>;
    })
  );
}

getAggregierteAuswertungLayoutById$Plain.PATH = '/v1/aggregierteAuswertung/layouts/{id}';
